import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-selectbutton" }
const _hoisted_2 = { class: "d-flex p-0" }
const _hoisted_3 = { style: {"font-size":"smaller"} }
const _hoisted_4 = { class: "colorMenu" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Button, { onClick: _ctx.toggleColorPicker }, {
        default: _withCtx(() => [
          _createElementVNode("span", {
            class: "material-symbols-outlined",
            style: _normalizeStyle(_ctx.selectedColor)
          }, _toDisplayString(_ctx.colorOptions.icon), 5)
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _createVNode(_component_OverlayPanel, { ref: "colorMenu" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("table", _hoisted_4, [
              _createElementVNode("tr", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.colorMenuItem.colors.length, (index) => {
                  return (_openBlock(), _createElementBlock("td", {
                    key: index,
                    style: {"padding":"0px 2px 6px 0px"}
                  }, [
                    _createElementVNode("div", {
                      style: _normalizeStyle('background-color: var(--' + _ctx.colorMenuItem.monochrome + '-' + (900 - (index * 100)) + ')'),
                      onClick: ($event: any) => (_ctx.selectColor('--' + _ctx.colorMenuItem.monochrome + '-' + (900 - (index * 100))))
                    }, null, 12, _hoisted_5)
                  ]))
                }), 128))
              ]),
              _createElementVNode("tr", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.colorMenuItem.colors, (color, color_index) => {
                  return (_openBlock(), _createElementBlock("td", {
                    key: color_index,
                    style: {"padding":"0px 2px 6px 0px"}
                  }, [
                    _createElementVNode("div", {
                      style: _normalizeStyle('background-color: var(--' + color + '-500)'),
                      onClick: ($event: any) => (_ctx.selectColor('--' + color + '-500'))
                    }, null, 12, _hoisted_6)
                  ]))
                }), 128))
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.colorMenuItem.colors.length, (index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.colorMenuItem.colors, (color, color_index) => {
                    return (_openBlock(), _createElementBlock("td", {
                      key: color_index,
                      style: {"padding":"0px 2px 2px 0px"}
                    }, [
                      _createElementVNode("div", {
                        style: _normalizeStyle('background-color: var(--' + color + '-' + (900 - (index * 100)) + ')'),
                        onClick: ($event: any) => (_ctx.selectColor('--' + color + '-' + (900 - (index * 100))))
                      }, " ", 12, _hoisted_7)
                    ]))
                  }), 128))
                ]))
              }), 128))
            ])
          ])
        ])
      ]),
      _: 1
    }, 512)
  ], 64))
}